import React from 'react';
import WithPicLayout from '../layout/WithPicLayout';

const ConferenceItem = ({ conference, image, imagePosition = 'right' }) => {
  const renderContentItem = (item) => {
    switch (item.type) {
      case 'abstract':
        return `Abstract: ${item.text}`;
      case 'presentation':
        return <strong><i>{item.text}</i></strong>;
      case 'location':
        return <strong>{item.text}</strong>;
      case 'organizer':
      case 'presenter':
      case 'context':
      case 'details':
      default:
        return item.text;
    }
  };

  return (
    <WithPicLayout image={image} imagePosition={imagePosition}>
      <p>
        <strong>{conference.dates}</strong>
        <br />
        <strong>{conference.title}</strong>
        <br />
        {conference.content?.map((item, index) => (
          <React.Fragment key={index}>
            {renderContentItem(item)}
            <br />
          </React.Fragment>
        ))}
      </p>
    </WithPicLayout>
  );
};

export default ConferenceItem;